import { Grid, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const Footer = () => {
  const loader = useSelector((state) => state.loader);
  console.log(loader);
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      color="primary"
      sx={{ height: 100, bgcolor: "primary.main", mt: "1200px" }}
    >
      <Grid item>
        <Typography variant="button" sx={{ color: "#fff" }}>
          Crypto Project Created With ❤️
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Footer;
